import { SelectionListServant } from './../../global/servants/selection_list_servant';
import { Major } from '../builders/major_builder';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { ITransferMajorsDatasource } from '../datasources/transfer_majors_datasource';

export class TransferMajorsSelectedQuery implements IQuery {
  private _result: {
    majors: Major[];
    areMaxSelected: boolean;
  };

  constructor(
    QueryMediator: IQueryMediator,
    private ngSelectionListServant: SelectionListServant,
    private ngTransferMajorsDatasource: ITransferMajorsDatasource
  ) {
    QueryMediator.registerQuery(this, ngTransferMajorsDatasource);
  }

  run(): TransferMajorsSelectedQuery {
    this._result = {
      majors: _(this.ngTransferMajorsDatasource.read())
        .filter((major: Major): boolean => major.isSelected)
        .sortBy('created_ts')
        .reverse()
        .value(),
      areMaxSelected:
        this.ngTransferMajorsDatasource.model.majorsSelection.list.length ===
        this.ngTransferMajorsDatasource.model.majorsSelection.maximum
    };

    this.ngSelectionListServant.reset(this.ngTransferMajorsDatasource.model.majorsSelection);

    _.each(this.ngTransferMajorsDatasource.cursor(this._result.majors), (major: Major): void => {
      this.ngSelectionListServant.select(this.ngTransferMajorsDatasource.model.majorsSelection, major);
    });

    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-transfer').service('ngTransferMajorsSelectedQuery', TransferMajorsSelectedQuery);



// WEBPACK FOOTER //
// ./app/lib/transfer/queries/transfer_majors_selected_query.ts